import { render } from "./AuctionFrom.vue?vue&type=template&id=871f2010"
import script from "./AuctionFrom.vue?vue&type=script&lang=js"
export * from "./AuctionFrom.vue?vue&type=script&lang=js"

import "./AuctionFrom.vue?vue&type=style&index=0&id=871f2010&lang=scss"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__